import { Group, Invoice as InvoiceType, UserRole } from '@intly/core';
import { FC, useMemo } from 'react';
import * as FileSaver from 'file-saver';

import {
  BlobProvider,
  Defs,
  LinearGradient,
  PDFViewer,
  Path,
  Rect,
  Stop,
  Svg,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { IoDownloadOutline } from 'react-icons/io5';
import { DateTime } from 'luxon';

const InvoiceLogo: React.FC<ElementsProps> = ({ owner }) => {
  if (owner === 'Aqord') {
    return (
      <View
        style={{
          height: 75,
        }}
      >
        <Text
          style={{
            fontSize: 30,
            color: 'rgba(181,15,115, 1)',
            // textAlign: 'center',
            fontWeight: 'bold',
            marginTop: 20,
            marginLeft: 30,
          }}
        >
          aQord
        </Text>
      </View>
    );
  }

  return (
    <Svg width="190" height="95" viewBox="0 0 760 380">
      <Path d="M112 224H196.518V249.229H112V224Z" fill="#8A56AC" />
      <Path
        fillRule="evenodd"
        // clipRule="evenodd"
        d="M154.857 212.022C139.532 212.022 127.058 207.567 117.435 198.657C107.812 189.747 103 178.698 103 165.511C103 152.324 107.812 141.276 117.435 132.365C127.058 123.455 139.532 119 154.857 119C170.183 119 182.657 123.277 192.28 131.831C201.903 140.384 206.715 151.077 206.715 163.907C206.715 177.807 201.903 189.391 192.28 198.657C182.657 207.567 170.183 212.022 154.857 212.022ZM154.847 188.364C147.208 188.364 140.991 186.143 136.194 181.702C131.398 177.261 129 171.755 129 165.182C129 158.609 131.398 153.102 136.194 148.661C140.991 144.22 147.208 142 154.847 142C162.485 142 168.702 144.132 173.499 148.395C178.295 152.658 180.693 157.988 180.693 164.383C180.693 171.311 178.295 177.084 173.499 181.702C168.702 186.143 162.485 188.364 154.847 188.364Z"
        fill="#8A56AC"
      />
      <Path
        d="M255 122.007C255 117.383 256.652 113.588 259.956 110.624C263.261 107.541 267.627 106 273.056 106C278.484 106 282.85 107.541 286.155 110.624C289.459 113.588 291.111 117.383 291.111 122.007C291.111 126.512 289.459 130.306 286.155 133.389C282.85 136.353 278.484 137.836 273.056 137.836C267.627 137.836 263.261 136.353 259.956 133.389C256.652 130.306 255 126.512 255 122.007Z"
        fill="#1F1F1F"
      />
      <Path
        d="M467 128.174C466.941 143.355 462.664 155.724 454.17 165.28C445.616 174.903 434.924 179.715 422.093 179.715C421.668 179.715 421.246 179.71 420.826 179.701L420.826 153.683C421.088 153.69 421.352 153.693 421.618 153.693C428.013 153.693 433.342 151.295 437.605 146.499C441.807 141.771 443.939 135.663 443.999 128.174L467 128.174Z"
        fill="#1F1F1F"
      />
      <Path
        d="M484.272 222.767V248.911H470.642C459.077 248.911 450.049 246.066 443.559 240.374C437.186 234.565 434 225.02 434 211.74V175.28V149.67H464.27H484.095V175.28H464.27V212.274C464.27 216.186 465.037 218.914 466.571 220.455C468.223 221.996 470.937 222.767 474.714 222.767H484.272Z"
        fill="#1F1F1F"
      />
      <Path d="M531.555 128V248.911H501.285V128H531.555Z" fill="#1F1F1F" />
      <Path
        d="M484.272 222.767V248.911H470.642C459.077 248.911 450.049 246.066 443.559 240.374C437.186 234.565 434 225.02 434 211.74V175.28V149.67H464.27H484.095V175.28H464.27V212.274C464.27 216.186 465.037 218.914 466.571 220.455C468.223 221.996 470.937 222.767 474.714 222.767H484.272Z"
        fill="#1F1F1F"
      />
      <Path d="M531.555 128V248.911H501.285V128H531.555Z" fill="#1F1F1F" />
      <Path
        d="M371.664 148C382.993 148 391.961 151.794 398.57 159.383C405.297 166.971 408.66 177.405 408.66 190.685V248.309H378.39V194.242C378.39 187.602 376.62 182.444 373.08 178.768C369.657 174.974 365.055 173.077 359.272 173.077C353.136 173.077 348.238 175.034 344.58 178.946C341.04 182.859 339.27 188.432 339.27 195.664V248.309H309V149.067H339.27V167.208C342.102 161.28 346.291 156.596 351.838 153.158C357.502 149.719 364.111 148 371.664 148Z"
        fill="#1F1F1F"
      />
      <Path d="M288.27 249.242V150H258V249.242H288.27Z" fill="#1F1F1F" />
      <Path
        d="M657.74 150L615.62 251.52C610.7 263.52 604.7 271.92 597.62 276.72C590.54 281.64 581.9 284.1 571.7 284.1C566.54 284.1 561.32 283.26 556.04 281.58C550.88 280.02 546.68 277.92 543.44 275.28L555.32 251.34C557.24 253.14 559.52 254.52 562.16 255.48C564.92 256.56 567.68 257.1 570.44 257.1C573.68 257.1 576.32 256.44 578.36 255.12C580.52 253.8 582.32 251.7 583.76 248.82L542 150H577.1L601.04 209.58L625.16 150H657.74Z"
        fill="#1F1F1F"
      />
    </Svg>
  );
};

interface ElementsProps {
  owner?: string | null;
}

const BackgroundGradient: React.FC<ElementsProps> = ({ owner }) => {
  const startColor =
    owner === 'Aqord' ? 'rgba(181,15,115, 1)' : 'rgba(138,86,172,1)';

  return (
    <Svg>
      <Defs>
        <LinearGradient id="intly" x1="0" x2="0" y1="0" y2="1">
          <Stop offset="0%" stopColor={startColor} stopOpacity="1" />
          <Stop offset="50%" stopColor="rgba(212,127,166,1)" stopOpacity="1" />
        </LinearGradient>
      </Defs>

      <Rect
        x="0"
        y="0"
        // rx="0"
        // ry="10"
        width="350"
        height="200"
        fill="url(#intly)"
      />
    </Svg>
  );
};

const s = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFF',
    wordBreak: 'keep-all',
    // margin: 10,
    fontSize: 12,
  },
  header: {
    fontSize: 10,
  },
  headerAddress: {
    marginLeft: 30,
    marginTop: -20,
  },
  address: {
    // alignSelf: 'flex-end',
    // margin: 10,
    marginTop: 0,
    marginBottom: 0,
  },
  invoiceHeader: {
    fontSize: 30,
    fontWeight: 200,
  },
  splitSection: {
    flexDirection: 'row',
    margin: 20,
    marginHorizontal: 20,
  },
  splitSectionItem: {
    flex: 0.5,
    padding: 10,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  paymentInfoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  paymentDetailRowItem: {
    // width: '100%',
    flexGrow: 1,
    borderBottom: '1px solid #000',
    marginBottom: 10,
  },
  footer: {
    flexDirection: 'row',
    marginHorizontal: 30,
    marginBottom: 30,
    fontSize: 10,
    justifyContent: 'space-evenly',
    // alignSelf: 'flex-end',
  },
});

export const getMailto = (
  { invoice, group }: InvoiceProps,
  appBaseUrl: string
): string => {
  const date = DateTime.fromFormat(
    invoice?.invoicePeriodStart ?? '',
    'yyyy-MM-dd'
  )
    .setLocale('sv')
    .toFormat('LLL');
  const isPrivate = group?.billing.isPrivate ?? false;

  const address =
    group?.billing?.email ??
    group?.members.find((m) => m.role === UserRole.ADMIN)?.user?.email ??
    '';
  const subject = `subject=Faktura ${invoice?.invoiceNumber} ${date} från ${
    group?.customerOf?.name ?? 'Intly'
  }`;

  const companyName = encodeURIComponent(group?.customerOf?.name ?? 'Intly');
  const companyWeb = encodeURIComponent(
    `https://${group?.customerOf?.web ?? 'www.intly.se'}`
  );
  const body = isPrivate
    ? `body=Hej%2C%0D%0A%0D%0ASenaste%20fakturan%20fr%C3%A5n%20${companyName}%20finns%20nu%20tillg%C3%A4nglig%20i%20portalen.%20%0D%0A%0D%0ALogga%20in%20eller%20f%C3%B6lj%20l%C3%A4nken%20nedan%20f%C3%B6r%20att%20se%20fakturan.%0D%0A%0D%0A${appBaseUrl}%3FsettingsDialog%3DSUBSCRIPTIONS%2CINVOICES`
    : `body=Hej%2C%0D%0A%0D%0AV%C3%A4nligen%20se%20faktura%20som%20PDF%20bifogad.%20G%C3%A4ller%20abonnemang%20%22${companyName}%22.%0D%0A%0D%0AH%C3%B6r%20av%20dig%20om%20det%20dyker%20upp%20n%C3%A5gra%20fr%C3%A5gor.%0D%0A%0D%0A${companyWeb}
  `;

  return `mailto:${address}?${subject}&${body}`;
};

const useInvoiceName = ({ invoice, group }: InvoiceProps) => {
  const { i18n } = useTranslation();
  const date = DateTime.fromFormat(
    invoice?.invoicePeriodStart ?? '',
    'yyyy-MM-dd'
  )
    .setLocale(i18n.language.split('-')[0])
    .toFormat('LLL');
  return `Faktura ${invoice?.invoiceNumber} ${date} ${
    group?.customerOf?.name ?? 'Intly'
  } - ${group?.name}.pdf`;
};

const formattingFn = (val: number, suffix = '') =>
  `${new Intl.NumberFormat('sv-SE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(val)}${suffix}`;

const PageFooter: React.FC<InvoiceProps> = ({ group }) => {
  return (
    <View style={[s.footer]}>
      <Text>Orgnr: {group?.customerOf?.orgNo ?? '559253-8820'}</Text>
      <View style={{ borderRight: '1px solid #000' }} />
      <Text>Bankgiro: {group?.customerOf?.bankGiro ?? '5497-7061'}</Text>
      <View style={{ borderRight: '1px solid #000' }} />

      <Text>Vat nr: {group?.customerOf?.vatNo ?? 'SE559253882001'}</Text>
      <View style={{ borderRight: '1px solid #000' }} />

      <Text>Säte: Stockholm</Text>
      <View style={{ borderRight: '1px solid #000' }} />

      <Text>Godkänd för F-skatt</Text>
    </View>
  );
};

interface SpecificationSectionProps extends InvoiceProps {}

const SpecificationSection: FC<SpecificationSectionProps> = ({ invoice, group }) => {
  const items = invoice?.items ?? [];
  const hasQuantity = items.some((item) => item.quantity != null);
  const hasUnitPrice = items.some((item) => item.unitPrice != null);

  const header: any = { borderBottom: '1px solid #000', paddingBottom: 3, marginBottom: 5, paddingRight: 4 };
  const cell: any = { paddingRight: 4, paddingBottom: 5 };
  const footer: any = { borderTop: '1px solid #000', paddingTop: 5 };

  return (
    <View style={{ fontSize: 10 }}>
      <View style={{ flexDirection: 'row' }}>
        <Text style={[header, { flex: 6 }]}>Beskrivning</Text>
        <Text style={[header, { flex: 6 }]}>Period</Text>
        {hasQuantity && <Text style={[header, { flex: 2, textAlign: 'right' }]}>Antal</Text>}
        {hasUnitPrice && <Text style={[header, { flex: 3, textAlign: 'right' }]}>À-pris</Text>}
        <Text style={[header, { flex: 3, textAlign: 'right' }]}>Exkl. moms</Text>
        <Text style={[header, { flex: 3, textAlign: 'right' }]}>Moms</Text>
        <Text style={[header, { flex: 2, textAlign: 'right' }]}>Moms %</Text>
        <Text style={[header, { flex: 3, textAlign: 'right' }]}>Belopp</Text>
      </View>
      {items.map((item, i) => item.isLongDescription ? (
        <View key={i} style={{ flexDirection: 'row' }}>
          <Text style={[cell, { flex: 1 }]}>{item.description}</Text>
        </View>
      ) : (
        <View key={i} style={{ flexDirection: 'row' }}>
          <Text style={[cell, { flex: 6 }]}>{item.description}</Text>
          <Text style={[cell, { flex: 6 }]}>{item.start}{' - '}{item.end}</Text>
          {hasQuantity && <Text style={[cell, { flex: 2, textAlign: 'right' }]}>{item.quantity ?? ' '}</Text>}
          {hasUnitPrice && <Text style={[cell, { flex: 3, textAlign: 'right' }]}>{item.unitPrice != null ? formattingFn(item.unitPrice, ' kr').replace('−', '-') : ' '}</Text>}
          <Text style={[cell, { flex: 3, textAlign: 'right' }]}>{formattingFn(item.amountNet, ' kr').replace('−', '-')}</Text>
          <Text style={[cell, { flex: 3, textAlign: 'right' }]}>{formattingFn(item.amount - item.amountNet, ' kr').replace('−', '-')}</Text>
          <Text style={[cell, { flex: 2, textAlign: 'right' }]}>25%</Text>
          <Text style={[cell, { flex: 3, textAlign: 'right' }]}>{formattingFn(item.amount, ' kr').replace('−', '-')}</Text>
        </View>
      ))}

      <View style={[footer, { flexDirection: 'row' }]}>
        <Text style={{ flex: 12, paddingRight: 4 }}>{group?.customerOf?.name ?? 'Intly'} till handa senast: {invoice?.dueDate}</Text>
        {hasQuantity && <Text style={{ flex: 2 }}> </Text>}
        {hasUnitPrice && <Text style={{ flex: 3 }}> </Text>}
        <Text style={{ flex: 3, textAlign: 'right' }}>{formattingFn(invoice?.amountNet ?? 0, ' kr').replace('−', '-')}</Text>
        <Text style={{ flex: 3, textAlign: 'right' }}>{formattingFn(invoice?.vat ?? 0, ' kr').replace('−', '-')}</Text>
        <Text style={{ flex: 2, textAlign: 'right' }}> </Text>
        <Text style={{ flex: 3, textAlign: 'right' }}>{formattingFn(invoice?.amount ?? 0, ' kr').replace('−', '-')}</Text>
      </View>
    </View>
  );
};

export interface InvoiceProps {
  invoice?: InvoiceType;
  group?: Group | null;
}

const Invoice: FC<InvoiceProps> = ({ invoice, group }) => {
  const invoiceName = useInvoiceName({ invoice, group });


  return (
    <Document title={invoiceName}>
      <Page size="A4" style={s.page}>
        <View style={s.header}>
          <InvoiceLogo owner={group?.customerOf?.name} />
          <View style={[s.headerAddress]}>
            <Text>
              {group?.customerOf?.name
                ? `${group?.customerOf?.name} AB`
                : 'Intly AB'}
            </Text>
            <Text>{group?.customerOf?.address ?? 'Gustavslundsvägen 12'}</Text>
            <Text>
              {group?.customerOf?.postalCode ?? '167 51'}{' '}
              {group?.customerOf?.city ?? 'Bromma'}
            </Text>
          </View>
        </View>
        <View style={[s.splitSection, s.address]}>
          <View style={s.splitSectionItem} />
          <View style={s.splitSectionItem}>
            <Text>
              {invoice?.billing?.isPrivate
                ? `${invoice?.billing?.firstName} ${invoice?.billing?.lastName}`
                : invoice?.billing?.companyName}
            </Text>
            <Text>{invoice?.billing?.address}</Text>
            <Text>
              {invoice?.billing?.postalCode} {invoice?.billing?.city}
            </Text>
          </View>
        </View>

        <View style={[s.splitSection, { marginTop: 100 }]}>
          <View style={[s.splitSectionItem]}>
            <Text style={[s.invoiceHeader, { alignSelf: 'center' }]}>
              {invoice?.refoundInvoiceId ? 'Kreditfaktura' : 'Faktura'}
            </Text>
            <View style={{ fontSize: 10, marginTop: 10 }}>
              <Text>
                Här kommer fakturan för din prenumeration på{' '}
                {group?.customerOf?.name ?? 'Intly'}.
              </Text>
              <Text style={{ marginVertical: 10 }}>
                Till höger ser du en sammanfattning av betalningsuppgifterna.
                Längre ner finner du detaljerad information.
              </Text>
              <Text>
                Om du undrar över något så har du våra kontaktuppgifter här - vi
                hjälper dig gärna om du har några frågor.
              </Text>

              <View style={{ textAlign: 'center', marginTop: 10 }}>
                <Text>Kontakta oss på:</Text>
                <Text>
                  Telefon: {group?.customerOf?.telephone ?? '0703-68 37 68'}
                </Text>
                <Text>
                  E-mail: {group?.customerOf?.email ?? 'kontakt@intly.se'}
                </Text>
                <Text>{group?.customerOf?.web ?? 'www.intly.se'}</Text>
              </View>
            </View>
          </View>
          <View
            style={[
              s.splitSectionItem,
              // {
              //   backgroundColor:
              //     'linear-gradient(90deg, rgba(138,86,172,1) 0%, rgba(212,127,166,1) 100%)',
              // },
            ]}
          >
            <View
              style={{
                padding: 10,
                color: '#E7E4E9',
              }}
            >
              <View
                style={{
                  position: 'absolute',
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                }}
              >
                <BackgroundGradient owner={group?.customerOf?.name} />
              </View>
              <Text style={{ fontSize: 16, marginBottom: 10 }}>
                Betalningsinformation
              </Text>
              <View
                style={[s.paymentInfoRow, { fontSize: 14, marginBottom: 5 }]}
              >
                <Text>
                  {invoice?.refoundInvoiceId
                    ? 'Er Tillgodo'
                    : 'Belopp att betala'}
                </Text>
                <Text>
                  {formattingFn(invoice?.amount ?? 0, 'kr').replace('−', '-')}
                </Text>
              </View>
              <View style={[s.paymentInfoRow]}>
                <Text>{group?.customerOf?.name ?? 'Intly'} till handa</Text>
                <Text>{invoice?.dueDate}</Text>
              </View>
              <View style={[s.paymentInfoRow]}>
                <Text>Fakturanummer</Text>
                <Text>{invoice?.invoiceNumber}</Text>
              </View>
              <View style={[s.paymentInfoRow]}>
                <Text>Kundnummer</Text>
                <Text>{invoice?.customerNumber}</Text>
              </View>

              <View style={[s.paymentInfoRow, { marginTop: 10 }]}>
                {invoice?.billing?.isPrivate ? (
                  <></>
                ) : (
                  <>
                    <Text>Er referens</Text>
                    <Text>{invoice?.billing?.reference}</Text>
                  </>
                )}
              </View>
              <View style={[s.paymentInfoRow]}>
                {invoice?.billing?.isPrivate ? (
                  <></>
                ) : (
                  <>
                    <Text>Ert vat nr</Text>
                    <Text>SE{invoice?.billing?.orgNo?.replace('-', '')}01</Text>
                  </>
                )}
              </View>
              <View style={[s.paymentInfoRow]}>
                <Text>Bankgiro</Text>
                <Text>{group?.customerOf?.bankGiro ?? '5497-7061'}</Text>
              </View>
              <View style={[s.paymentInfoRow]}>
                <Text>Fakturadatum</Text>
                <Text>{invoice?.invoiceDate}</Text>
              </View>
            </View>
            <View style={{ backgroundColor: '#f1f0f2', padding: 10 }}>
              <Text style={{ fontSize: 16, marginBottom: 10 }}>Meddelande</Text>
              <Text>
                {invoice?.message
                  ? invoice.message
                  : 'Vänligen ange fakturanummer som meddelande vid betalning.'}
              </Text>
            </View>
          </View>
        </View>

        {group?.customerOf?.name !== 'Aqord' ? (
          <View
            style={[
              s.section,
              { marginHorizontal: 10, marginTop: 10, flex: 1 },
            ]}
          >
            <Text style={{ fontSize: 18, marginBottom: 5 }}>Specifikation</Text>

            <SpecificationSection invoice={invoice} group={group} />

            <Text style={{ fontSize: 8, marginTop: 5 }}>
              Vid betalning efter förfallodag utgår dröjsmålsränta enligt
              gällande räntelag.
            </Text>
          </View>
        ) : (
          <View
            style={[
              s.section,
              { marginHorizontal: 10, marginTop: 10, flex: 1 },
            ]}
          >
            <Text style={{ fontSize: 12, marginBottom: 5 }}>
              Specifikation på sida 2
            </Text>
          </View>
        )}

        <PageFooter group={group} />
      </Page>

      {group?.customerOf?.name === 'Aqord' && (
        <Page size="A4" style={s.page}>
          <View
            style={[
              s.section,
              { marginHorizontal: 10, marginTop: 10, flex: 1 },
            ]}
          >
            <Text style={{ fontSize: 18, marginBottom: 5 }}>Specifikation</Text>
            <SpecificationSection invoice={invoice} group={group} />
            <Text style={{ fontSize: 8, marginTop: 5 }}>
              Vid betalning efter förfallodag utgår dröjsmålsränta enligt
              gällande räntelag.
            </Text>
          </View>
          <PageFooter group={group} />
        </Page>
      )}
    </Document>
  );
};

export const InvoicePreview: FC<InvoiceProps> = ({ invoice, group }) => {
  return (
    <PDFViewer
      style={{
        height: '1000px',
        width: '100%',
      }}
    >
      <Invoice invoice={invoice} group={group} />
    </PDFViewer>
  );
};

export const InvoiceDownload: FC<InvoiceProps> = ({ invoice, group }) => {
  const { t } = useTranslation();

  const invoiceName = useInvoiceName({ invoice, group });
  return (
    <BlobProvider document={<Invoice invoice={invoice} group={group} />}>
      {({ blob, url, loading, error }) =>
        loading || blob === null ? (
          <IconButton disabled size="small">
            <IoDownloadOutline />
          </IconButton>
        ) : (
          <Tooltip title={t('DOWNLOAD')}>
            <IconButton
              size="small"
              onClick={() => {
                FileSaver.saveAs(blob, invoiceName);
              }}
            >
              <IoDownloadOutline />
            </IconButton>
          </Tooltip>
        )
      }
    </BlobProvider>
  );
};

export default InvoicePreview;
